"use client";
import { LoaderComponent } from "@/components";
import { useRouter } from "@/i18n/routing";
import {
  GET_PRODUCT_APPLICATION,
  PRODUCT_HANDLER,
  STAGE_BASED_ROUTING,
  WEB_EVENTS,
} from "@/lib/constants";
import { useFooter } from "@/lib/context/FooterContext";
import useErrorHandling from "@/lib/hooks/errorhandling";
import { sendEventAnalytics } from "@/lib/hooks/eventAnalytics";
import useLogoutHook from "@/lib/hooks/logoutHook";
import {
  useGetApplicationQuery,
  useGetCustomerQuery,
  useGetOffersQuery,
  useUpdateOfferMutation,
  useUpdateOfferSliderMutation,
} from "@/lib/redux";
import { Stack } from "@mui/material";
import { useTranslations } from "next-intl";
import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import OfferSelectionBody from "./selection-body";
import OfferSelectionHeader from "./selection-header";
import { checkForRpl } from "@/lib/utils/rpl.utils";

const OfferSelectionScreen = ({ product }) => {
  const t = useTranslations("IdentityDetails");
  const router = useRouter();
  const searchParams = useSearchParams();
  const offerId = searchParams.get("offerId");
  const { setActions } = useFooter();
  // const selectedOfferData = useSelector(
  //   (state) => state?.offerselection?.offerSelectedData
  // );
  // const offerData = selectedOfferData?.offerData;
  const {
    data: applicationData,
    isLoading: applicationLoading,
    error: errorGetApplication,
    refetch: refetchApplicationData,
  } = useGetApplicationQuery("", {
    refetchOnMountOrArgChange: true,
  });

  const { data: customerData, isLoading: fetchingCustomer } =
    useGetCustomerQuery();

  //API COMMON ENITITIES
  const productApplication = GET_PRODUCT_APPLICATION(
    PRODUCT_HANDLER[product],
    applicationData?.data
  );
  const {
    data: offersData,
    error: errorOffers,
    isFetching: isfetchingOffer,
  } = useGetOffersQuery(
    {
      appId: productApplication?.appId,
      isRPL: checkForRpl(productApplication),
    },
    {
      skip: !productApplication?.appId,
      refetchOnMountOrArgChange: true,
    },
  );

  //selected offer slider change API call from this function
  const [
    updateOfferSlider,
    {
      data: updateOfferSliderData,
      error: errorUpdateOfferSlider,
      isLoading: UpdateOfferSliderLoading,
      isSuccess: isScussessUpdateOfferSlider,
    },
  ] = useUpdateOfferSliderMutation();

  //update offer API call from this function
  const [
    updateOffer,
    {
      data: updateOfferData,
      error: errorUpdateOffer,
      isLoading: UpdateOfferLoading,
    },
  ] = useUpdateOfferMutation();
  const selectedItem = offersData?.data?.offers?.find(
    (item) => item?.id === Number(offerId)
  );
  const [emi, setEmi] = useState(selectedItem?.emi);
  const [amount, setAmount] = useState(selectedItem?.amount);
  /*******************************RTK*******************************/

  const isError =
    errorGetApplication || errorUpdateOfferSlider || errorUpdateOffer;
  const isLoading =
    applicationLoading ||
    UpdateOfferSliderLoading ||
    UpdateOfferLoading ||
    fetchingCustomer ||
    isfetchingOffer;
  /*******************************EFFECTS*******************************/
  //dispaly errors
  useErrorHandling(isError);
  useEffect(() => {
    if (isScussessUpdateOfferSlider) {
      setEmi(updateOfferSliderData?.data?.offersDetails?.emi);
    }
  }, [isScussessUpdateOfferSlider]);

  useEffect(() => {
    if (updateOfferData?.data?.stage) {
      refetchApplicationData();
    }
  }, [updateOfferData]);

  useEffect(() => {
    if (productApplication?.stage && productApplication?.stage !== "OFFERS") {
      refreshbtn();
    }
  }, [productApplication?.stage]);

  /*******************************ACTION*******************************/
  const refreshbtn = () => {
    router.push(STAGE_BASED_ROUTING(productApplication?.stage));
  };

  const handleCalculateEmi = (newValue) => {
    setAmount(newValue);
    updateOfferSlider({
      body: {
        appId: productApplication?.appId,
        offerId: selectedItem?.id,
        newRequestLoanAmount: newValue,
      },
      isRPL: checkForRpl(productApplication),
    });
  };

  const proceedWithSelection = () => {
    sendEventAnalytics({
      eventName:  checkForRpl(productApplication)
        ? WEB_EVENTS.RL_OFFER_ACCEPTED
        : WEB_EVENTS.SELECTED_LOAN_AMOUNT_AGREE,
      ...productApplication,
      ...customerData?.data,
    });
    const requestData = {
      appId: parseInt(productApplication?.appId),
      offerId: selectedItem?.id,
      newRequestLoanAmount:
        selectedItem?.offerType === "RECOMMENDED" || selectedItem?.slider
          ? amount
          : "",
    };
    updateOffer(requestData);
  };

  useEffect(() => {
    setActions({
      showReject: false,
      showConfirm: true,
      onConfirm: proceedWithSelection,
      confirmBtnLabel: "Continue",
      disabledConfirmBtn: !selectedItem,
    });
  }, [setActions, amount, selectedItem]);
  /*******************************RENDER*******************************/
  return (
    <>
      <LoaderComponent open={isLoading} />
      <Stack spacing={5} mb={5}>
        <OfferSelectionHeader
          offerData={offersData?.data}
          selectedItem={selectedItem}
          amount={amount}
          handleSliderClculation={handleCalculateEmi}
          updateOfferSliderData={updateOfferSliderData?.data?.offersDetails}
        />
        <OfferSelectionBody
          offerData={offersData?.data}
          selectedItem={selectedItem}
          updateOfferSliderData={updateOfferSliderData?.data?.offersDetails}
        />
      </Stack>
    </>
  );
};

export default OfferSelectionScreen;
